import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { ShareResourceEnum } from '../enum/share-resource-enum'
import { ShareResourceInterface, ShareResourceNewFlowInterface } from '../types/share-interface'
import { getResourceApiSlug } from '../utils/get-resource-api-slug'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'

export const useShareResource = ({ hash, type }: { hash?: string; type?: ShareResourceEnum }) => {
  const resourceApiSlug = getResourceApiSlug(type)
  const isNewFlow = type === ShareResourceEnum.Workflow

  const { fetcher } = useFetch<RequestMethodsEnum.get, ShareResourceInterface>({
    method: RequestMethodsEnum.get,
    badRequestHandler(error) {
      throw error
    },
  })

  const { fetcher: postNewFlowFetcher } = useFetch<
    RequestMethodsEnum.post,
    ShareResourceNewFlowInterface
  >({
    method: RequestMethodsEnum.post,
    badRequestHandler(error) {
      throw error
    },
  })

  const { data: oldFlowData, error: oldFlowError } = useControlledSwr(
    () => {
      if (!hash || !type) return
      switch (resourceApiSlug) {
        case ShareResourceEnum.Funnel:
          return `/api/funnel/share-background/${hash}`
        case ShareResourceEnum.Blog:
          return `/api/blog/share-background/${hash}`
        default:
          return `/api/${resourceApiSlug}/share/${hash}`
      }
    },
    fetcher,
    undefined,
    !isNewFlow,
  )

  const { data: newFlowData, error: newFlowError } = useControlledSwr(
    () => {
      if (!hash) return
      return `/api/dashboard/sharing/share/${hash}`
    },
    postNewFlowFetcher,
    undefined,
    isNewFlow,
  )

  return {
    data: isNewFlow ? newFlowData : oldFlowData,
    error: isNewFlow ? newFlowError : oldFlowError,
  }
}
